<template>
  <div class="container">
    <arrorImg bg="white"></arrorImg>
    <navBar :title="title" color="#ffffff"></navBar>
    <div class="container_box">
        	  <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  :infinite-scroll-immediate-check="false"
  infinite-scroll-distance="10">
      <li
        v-for="(item, index) in List"
        :key="index"
        @click="routeDetail(item)"
      >
        <uniListItem :itemChild="item"></uniListItem>
      </li>
            </ul>
      <div class="load-more">
        <span>{{ !isLoading ?'加载中':loadText }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import uniListItem from "../components/list-item.vue";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name:'bookList',
  components: {
    uniListItem,
    arrorImg,
    navBar,
  },
  data() {
    return {
      loading:false,
      bookAuthor: "",
      bookId: 0,
      category: "",
      List: [],
      title: "",
      loadText: "正在加载中",
      isLoading:false,
      CountPage:0,
      pageNo: 1,
      pageSize: 10,
      isEntranceData: "",
      messageType: "",
      clickMessId: 0,
      channelRecordId: 0,
      promotionCode: "",
      listId:[]
    };
  },
   watch: {
    $route: {
      // 监听路由的参数变化
      handler(val,old) {
        if(val.name=='bookList'&&(val.query.bookId!=this.bookId||val.query.title!=this.title)){
            this.title = val.query.title;
              this.bookAuthor = val.query.bookAuthor;
              this.bookId = val.query.bookId;
              this.category = val.query.category;
          this.initData();
        }
      }
    },
  },
  mounted() {
   this.initData();
  },
     beforeRouteLeave(to, from, next) {
     if(from.name=='bookList'&&to.name == "bookDetail"){
      from.meta.isBack = true;
      from.meta.keepAlive = true;
     }else{
        from.meta.isBack = false;
      from.meta.keepAlive = false;
     }
    next();
  },
  activated(){
  },
  methods: {
    initData(){
       this.title = this.$route.query.title;
    this.bookAuthor = this.$route.query.bookAuthor;
    this.bookId = this.$route.query.bookId;
    this.category = this.$route.query.category;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
        	 var city = this.$base.getStorage("city");
      this.pageNo=1;
      this.CountPage=0;
      this.List=[];
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      if (this.title == "该作者其它作品") {
        this.getAuthorBooks();
      } else {
        this.getGuessYourLikeList();
      }
     
      this.insertPageAccessData();
    } else {
      if (this.title == "该作者其它作品") {
        this.getAuthorBooks();
      } else {
        this.getGuessYourLikeList();
      }
      this.insertPageAccessData();
    }
    this.$commonApi.share();
    },
     loadMore() {
		this.loading = true;
          if (this.pageNo < this.CountPage) {
            console.log(this.pageNo)
            console.log(this.CountPage)
          this.pageNo += 1;
          if (this.title == "该作者其它作品") {
            this.getAuthorBooks();
          } else {
            this.getGuessYourLikeList();
          }
        } else {
          	this.loading = false;
          this.loadText = "没有更多了";
        }
		},
  
    insertPageAccessData() {
      var params = {
        pageName: this.title,
        pageRemark: "上级页面：书籍详情;书籍ID：" + this.bookId,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getAuthorBooks() {
       this.listId=[];
      this.List.forEach(item=>{
        this.listId.push(item.id)
      })
      console.log(this.listId)
      var params = {
        bookAuthor: this.bookAuthor,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        idColllection:this.listId
      };
      this.isLoading=false;
      this.$api.getAuthorBooks(params).then((res) => {
        if (res.status == 1) {
          this.CountPage = res.pages;
          console.log(this.CountPage)
          res.data.forEach((obj, index) => {
            var num = (obj.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              obj.studyingVolume = 999.99;
            } else {
              obj.studyingVolume = num;
            }
          });
          if (this.pageNo == 1) {
            this.List = res.data;
            if (this.CountPage > 1) {
              this.loadText = "加载中...";
            } else {
              this.loadText = "没有更多了";
            }
          } else {
            this.List = this.List.concat(res.data);
          }
          this.isLoading=true;
        }
      });
    },
    routeDetail(item) {
      this.$router.push({
        path: "/pages/bookDetail/index",
        query: {
          bookId: item.id,
          pageDetail: "bookList",
        },
      });
    },
    getGuessYourLikeList() {
      this.listId=[];
      this.List.forEach(item=>{
        this.listId.push(item.id)
      })
       console.log(this.listId)
      var params = {
        bookId: this.bookId,
        category: this.category,
        booktype: "",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isBookDetail:0,
        idColllection:this.listId
      };
       this.isLoading=false;
      this.$api.getGuessYourLikeList(params).then((res) => {
        if (res.status == 1) {
          this.CountPage = res.pages;
          res.data.forEach((obj) => {
            var num = (obj.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              obj.studyingVolume = 999.99;
            } else {
              obj.studyingVolume = num;
            }
          });
          if (this.pageNo == 1) {
            this.List = res.data;
            if (this.CountPage > 1) {
              this.loadText = "加载中...";
            } else {
              this.loadText = "没有更多了";
            }
          } else {
            this.List = this.List.concat(res.data);
          }
           this.isLoading=true;
          console.log(res);
        }
      });
    },
  },
};
</script>

<style scoped>
.container_box {

  padding-top: calc(44px + env(safe-area-inset-top));
}
.container {
  padding: 0px 16px;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.load-more {
  text-align: center;
    font-size: 12px;
color: #AAAAAA;
  padding: 16px 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookList/index.vue